module.exports = __webpack_public_path__ + "img/InterestRate.0eeb3eb7.svg";